import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Auth\BankID\AuthenticationOrderController::create
* @see app/Http/Controllers/Auth/BankID/AuthenticationOrderController.php:22
* @route '/bank-id/order/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: create.url(options),
    method: 'post',
})

create.definition = {
    methods: ["post"],
    url: '/bank-id/order/create',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\BankID\AuthenticationOrderController::create
* @see app/Http/Controllers/Auth/BankID/AuthenticationOrderController.php:22
* @route '/bank-id/order/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\BankID\AuthenticationOrderController::create
* @see app/Http/Controllers/Auth/BankID/AuthenticationOrderController.php:22
* @route '/bank-id/order/create'
*/
create.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: create.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Auth\BankID\AuthenticationOrderController::store
* @see app/Http/Controllers/Auth/BankID/AuthenticationOrderController.php:46
* @route '/bank-id/order/store'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/bank-id/order/store',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\BankID\AuthenticationOrderController::store
* @see app/Http/Controllers/Auth/BankID/AuthenticationOrderController.php:46
* @route '/bank-id/order/store'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\BankID\AuthenticationOrderController::store
* @see app/Http/Controllers/Auth/BankID/AuthenticationOrderController.php:46
* @route '/bank-id/order/store'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Auth\BankID\AuthenticationOrderController::show
* @see app/Http/Controllers/Auth/BankID/AuthenticationOrderController.php:71
* @route '/bank-id/order/show'
*/
export const show = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: show.url(options),
    method: 'post',
})

show.definition = {
    methods: ["post"],
    url: '/bank-id/order/show',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\BankID\AuthenticationOrderController::show
* @see app/Http/Controllers/Auth/BankID/AuthenticationOrderController.php:71
* @route '/bank-id/order/show'
*/
show.url = (options?: RouteQueryOptions) => {
    return show.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\BankID\AuthenticationOrderController::show
* @see app/Http/Controllers/Auth/BankID/AuthenticationOrderController.php:71
* @route '/bank-id/order/show'
*/
show.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: show.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Auth\BankID\AuthenticationOrderController::destroy
* @see app/Http/Controllers/Auth/BankID/AuthenticationOrderController.php:109
* @route '/bank-id/order/destroy'
*/
export const destroy = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: destroy.url(options),
    method: 'post',
})

destroy.definition = {
    methods: ["post"],
    url: '/bank-id/order/destroy',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\BankID\AuthenticationOrderController::destroy
* @see app/Http/Controllers/Auth/BankID/AuthenticationOrderController.php:109
* @route '/bank-id/order/destroy'
*/
destroy.url = (options?: RouteQueryOptions) => {
    return destroy.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\BankID\AuthenticationOrderController::destroy
* @see app/Http/Controllers/Auth/BankID/AuthenticationOrderController.php:109
* @route '/bank-id/order/destroy'
*/
destroy.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: destroy.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Auth\BankID\AuthenticationOrderController::switchDevice
* @see app/Http/Controllers/Auth/BankID/AuthenticationOrderController.php:123
* @route '/bank-id/order/switch-device'
*/
export const switchDevice = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: switchDevice.url(options),
    method: 'post',
})

switchDevice.definition = {
    methods: ["post"],
    url: '/bank-id/order/switch-device',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\BankID\AuthenticationOrderController::switchDevice
* @see app/Http/Controllers/Auth/BankID/AuthenticationOrderController.php:123
* @route '/bank-id/order/switch-device'
*/
switchDevice.url = (options?: RouteQueryOptions) => {
    return switchDevice.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\BankID\AuthenticationOrderController::switchDevice
* @see app/Http/Controllers/Auth/BankID/AuthenticationOrderController.php:123
* @route '/bank-id/order/switch-device'
*/
switchDevice.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: switchDevice.url(options),
    method: 'post',
})

const order = {
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    show: Object.assign(show, show),
    destroy: Object.assign(destroy, destroy),
    switchDevice: Object.assign(switchDevice, switchDevice),
}

export default order